export var FILTER_TYPES;
(function(FILTER_TYPES) {
    FILTER_TYPES["eq"] = "_eq";
    FILTER_TYPES["gt"] = "_gt";
    FILTER_TYPES["gte"] = "_gte";
    FILTER_TYPES["ilike"] = "_ilike";
    FILTER_TYPES["in"] = "_in";
    FILTER_TYPES["is_null"] = "_is_null";
    FILTER_TYPES["like"] = "_like";
    FILTER_TYPES["lt"] = "_lt";
    FILTER_TYPES["lte"] = "_lte";
    FILTER_TYPES["nilike"] = "_nilike";
})(FILTER_TYPES || (FILTER_TYPES = {}));
export var FILTER_OPERATORS;
(function(FILTER_OPERATORS) {
    FILTER_OPERATORS["and"] = "_and";
    FILTER_OPERATORS["or"] = "_or";
})(FILTER_OPERATORS || (FILTER_OPERATORS = {}));

//# sourceMappingURL=filter.js.map